import { useCookies } from "vue3-cookies";

const cookiesHelper = {
  getCookie(key) {
    return useCookies().cookies.get(key);
  },

  setCookie(key, value) {
      useCookies().cookies.set(key, value);

  },

  clearCookie(key) {
      useCookies().cookies.remove(key);

  },

  clearCookies() {
    useCookies().cookies.keys().forEach((key) => {
        useCookies().cookies.remove(key);
    })
  },
};

export default cookiesHelper;
